module.exports = __webpack_public_path__ + "img/8955D0_744CC4_EA4AEF_954DA4-256px.08025ea6.png";